import React from 'react'

import { exists, type RowInfo } from '~/utils'

import { type SequentialColumnKey } from '../utils'

export const useExpandText = (tableInfo: RowInfo<SequentialColumnKey>[]) => {
  const [isTextExpanded, setIsTextExpanded] = React.useState(false)

  const handleTextExpandedChange = React.useCallback(() => {
    setIsTextExpanded((prev) => !prev)
  }, [])

  const textLineCount = React.useMemo(() => {
    if (!isTextExpanded) {
      return 1
    }
    const row = tableInfo.reduce((acc, row) => {
      let textLineCount = acc
      const answerText = row.answerText
      const text = answerText?.text
      const textCharacterLimit = answerText?.textCharacterLimit

      if (exists(text) && exists(textCharacterLimit)) {
        if (textCharacterLimit < `${text}`.length) {
          textLineCount = 2
        }
      }

      return textLineCount
    }, 1)

    return row
  }, [tableInfo, isTextExpanded])

  return { handleTextExpandedChange, isTextExpanded, textLineCount }
}
